// Migrated from app/assets/javascripts/yellow.js
// Yellow layout (ticketshop) entrypoint

import 'libraries/jquery-global'
import 'popper.js'
import 'bootstrap'
import toastr from 'toastr'
window.toastr = toastr
import 'vendor/bootbox-4.3.0'
// resizer + iframeResizer.contentWindow loaded as sync <script> in layout
import 'flipdown'

// jQuery extensions
import 'vendor/jquery.prettyPhoto'
import 'vendor/jquery.prevent_double_click'

// jQuery validation
import 'jquery-validation'

import 'libraries/idle'

// Yellow legacy inline code
import 'libraries/yellow-legacy'

import { Application } from "@hotwired/stimulus"
import PostcodeLookupController from '../controllers/postcode_lookup_controller'
const application = Application.start()
application.register("postcode-lookup", PostcodeLookupController)
